import { tns } from 'tiny-slider/src/tiny-slider';

/*
 *  <div class="c-slider" data-js-tiny-slider>
 *  </div>
 *  <div class="c-clider__controls">
 *    <div class="c-slider__dots">
 *    </div>
 *    <div class="c-slider__arrows">
 *    </div>
 *  </div>
 */

class TinySlider {
  constructor(el) {
    this.el = el;
    this.inner = el.querySelector('.c-slider__inner');
    this.controls = el.querySelector('.c-slider__arrows');
    this.nav = el.querySelector('.c-slider__dots');

    this.slider = tns({
      container: this.inner,
      items: 1,
      gutter: 50,
      autoplay: false,
      controlsContainer: this.controls,
      navContainer: this.nav,
      navAsThumbnails: true,
      responsive: {
        '600': {
          items: 2
        },
        '992': {
          items: 3
        }
      }
    });
  }
}

const sliders = [...document.querySelectorAll('[data-js-tiny-slider]')];

if (sliders.length > 0) {
  const Sliders = sliders.forEach((e, i) => {
    return new TinySlider(e);
  });
}
